module.exports = __webpack_public_path__ + "assets/img/index-banner1-1-tp.8c9b4420.jpg";